import { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { template } from '@belong/common';
import { Text, Button, Spinner } from '@belong/ui';
import { ApprovalContext } from 'pages/PostInspectionFlow/steps/Improvements/Approval/ApprovalContext';
import { getExclusivityAgreementURL } from 'store/redux/post-inspection-flow/actions';
import { POST_INSPECTION_FLOW_STRINGS } from 'strings/post-inspection-flow';

export function ExclusivityBanner() {
  const [
    isDownloadingExclusivityAgreement,
    setIsDownloadingExclusivityAgreement,
  ] = useState(false);
  // The local `ApprovalContext` type and the `as Context<…>` cast that used to
  // stand here are gone: the context now declares its own keys, so `group` and
  // `flow` come straight off it.
  const { group, flow } = useContext(ApprovalContext);
  const dispatch = useDispatch();

  async function handleViewAgreementClick() {
    setIsDownloadingExclusivityAgreement(true);

    const { url } = (await dispatch(
      getExclusivityAgreementURL(flow.uniqueId),
    )) as unknown as Record<'url', string>;

    window.open(url, '_blank');

    setIsDownloadingExclusivityAgreement(false);
  }

  return (
    <div className="relative mt-xl rounded border border-solid border-gray bg-light-gray p-sm md:mt-xs">
      {isDownloadingExclusivityAgreement && <Spinner className="rounded" />}
      <Text as="span">
        {template(POST_INSPECTION_FLOW_STRINGS['exclusivity-banner'], {
          years: group.yearsOfExclusivity,
        })}
      </Text>
      &nbsp;
      <Button onClick={handleViewAgreementClick} variant="text">
        {POST_INSPECTION_FLOW_STRINGS['exclusivity-agreement-url']}
      </Button>
    </div>
  );
}
